import React, { Suspense, lazy } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { theme } from "./theme";
import { AuthProvider } from "./contexts/AuthContext";
import { UserProvider } from "./contexts/UserContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { CircularProgress, Box } from "@mui/material";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import Terms from "./pages/legal/Terms";
import MobileRedirect from "./components/MobileRedirect";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Lazy load the HomePage component
const HomePage = lazy(() => import("./pages/HomePage"));

// Loading component
const LoadingScreen = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="100vh"
  >
    <CircularProgress />
  </Box>
);

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <UserProvider>
            <SettingsProvider>
              <Router>
                <Suspense fallback={<LoadingScreen />}>
                  <Routes>
                    {/* Allow access to landing page */}
                    <Route path="/" element={<HomePage />} />

                    {/* Allow access to legal pages */}
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<Terms />} />

                    {/* Redirect auth routes to mobile redirect page */}
                    <Route
                      path="/account-access"
                      element={<MobileRedirect />}
                    />
                    <Route
                      path="/create-account"
                      element={<MobileRedirect />}
                    />
                    <Route
                      path="/forgot-password"
                      element={<MobileRedirect />}
                    />
                    <Route
                      path="/reset-password/:token"
                      element={<MobileRedirect />}
                    />

                    {/* Redirect dashboard and all other pages */}
                    <Route path="/dashboard/*" element={<MobileRedirect />} />
                    <Route path="/documentation" element={<MobileRedirect />} />
                    <Route path="/pricing-sheet" element={<MobileRedirect />} />
                    <Route
                      path="/profile/:referralCode"
                      element={<MobileRedirect />}
                    />

                    {/* Catch all other routes */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
                <ToastContainer />
              </Router>
            </SettingsProvider>
          </UserProvider>
        </AuthProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
